import React, { useContext } from 'react';
import { v1 as uuidV1 } from 'uuid';
import { ModalsStateContext, ModalsDispatchContext } from './ModalContext';

type ModalPropsType = {
  props: {
    title?: string | React.ReactElement;
    content?: string;
    submitLabel?: string;
    cancelLabel?: string;
    onClose?: Function;
    onClickSubmit?: Function;
    onClickCancel?: Function;
    onClickClose?: Function;
    children?: React.ReactNode;
  };
  Component: (props: any) => React.ReactElement;
};

const Modals = (): React.ReactElement => {
  const openedModals = useContext(ModalsStateContext);
  const { close } = useContext(ModalsDispatchContext);

  return (
    <>
      {openedModals.map(
        ({ Component, props }: ModalPropsType, index): React.ReactElement => {
          const onClose = () => {
            close(Component);
          };

          return (
            <div className={`z-${index * 10}`} key={uuidV1()}>
              <Component {...props} onClose={onClose} />
            </div>
          );
        },
      )}
    </>
  );
};

export default Modals;
